import React from 'react'
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";

export const SidebarData = [
    {
        title: 'Home',
        path: '/',
        icon: <AiIcons.AiFillHome />,
        cName: 'nav-text'
    },
    {
        title: 'Update License',
        path: '/UpdateLicense',
        icon: <FaIcons.FaEdit />,
        cName: 'nav-text'
    },
    {
        title: 'S3 Uploads',
        path: '/S3Uploads',
        icon: <AiIcons.AiOutlineCloudUpload />,
        cName: 'nav-text'
    },
    {
        title: 'Addional Features',
        path: '/Extras',
        icon: <AiIcons.AiOutlinePaperClip />,
        cName: 'nav-text'
    }
]